const initialState = [];

const referenceDocumentsReducer = (state = initialState, action) => {
      switch (action.type) {
            case 'UPDATE_REFERENCE_DOCUMENTS':
                  return action.content;
            case 'LOGOUT_USER':
                  return [];
            default:
                  break;
      }
      return state;
};
export default referenceDocumentsReducer;